import React, { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import useSEO from '../hooks/useSEO';
import './JollyGunjParty.css';

const JollyGunjParty = () => {
  const UPI_ID = 'shyamachuthan@icici';
  const PAYEE_NAME = 'Shyam';

  const partyMembers = [
    { name: 'Kiran', amount: 1039 },
    { name: 'Akash', amount: 1104 },
    { name: 'Nevil', amount: 1787 },
    { name: 'Adithya', amount: 1662 },
    { name: 'Rohan', amount: 2042 },
    { name: 'Farhan', amount: 819 },
    { name: 'Vinod', amount: 1636 },
  ];

  const [selectedPerson, setSelectedPerson] = useState(null);
  const [copied, setCopied] = useState(false);

  useSEO({
    title: 'Jolly Gunj Party - Split Payment',
    description: 'Pay your share for the amazing Jolly Gunj party. Quick and easy UPI payment.'
  });

  const generateUPIString = (amount) => {
    let upiString = `upi://pay?pa=${encodeURIComponent(UPI_ID)}&pn=${encodeURIComponent(PAYEE_NAME)}`;
    upiString += `&am=${encodeURIComponent(amount)}`;
    upiString += `&tn=${encodeURIComponent(`Jolly Gunj Party - ${selectedPerson?.name}`)}`;
    upiString += '&cu=INR';
    return upiString;
  };

  const payWithGooglePay = () => {
    if (!selectedPerson) return;
    const upiString = generateUPIString(selectedPerson.amount);
    window.location.href = `gpay://upi/pay?${upiString.split('?')[1]}`;
    setTimeout(() => {
      window.location.href = upiString;
    }, 1000);
  };

  const payWithPhonePe = () => {
    if (!selectedPerson) return;
    const upiString = generateUPIString(selectedPerson.amount);
    window.location.href = `phonepe://pay?${upiString.split('?')[1]}`;
    setTimeout(() => {
      window.location.href = upiString;
    }, 1000);
  };

  const payWithAnyUPI = () => {
    if (!selectedPerson) return;
    window.location.href = generateUPIString(selectedPerson.amount);
  };

  const copyUpiId = () => {
    navigator.clipboard.writeText(UPI_ID);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleBack = () => {
    setSelectedPerson(null);
  };

  const totalAmount = partyMembers.reduce((sum, p) => sum + p.amount, 0);

  return (
    <div className="jg-page">
      <div className="jg-container">
        {!selectedPerson ? (
          <>
            {/* Welcome Section */}
            <div className="jg-header">
              <div className="jg-logo">🍻</div>
              <h1 className="jg-title">Jolly Gunj Party</h1>
              <p className="jg-subtitle">Split Payment</p>
            </div>

            <div className="jg-message">
              <h2>Thank You Everyone! 🎉</h2>
              <p>
                What an amazing night at <strong>Jolly Gunj</strong> on <strong>November 25th</strong>!
                Thank you all for making it such a memorable evening. Your presence, laughter,
                and good vibes made the party truly special.
              </p>
              <p>
                Here's the split for the evening. Select your name below to pay your share.
              </p>
            </div>
{/* 
            <div className="jg-total">
              <span>Total Bill</span>
              <span className="jg-total-amount">₹{totalAmount.toLocaleString()}</span>
            </div> */}

            <div className="jg-members-list">
              <h3 className="jg-section-title">Select Your Name</h3>
              {partyMembers.map((person) => (
                <button
                  key={person.name}
                  className="jg-member-btn"
                  onClick={() => setSelectedPerson(person)}
                >
                  <span className="jg-member-name">{person.name}</span>
                  <span className="jg-member-amount">₹{person.amount.toLocaleString()}</span>
                </button>
              ))}
            </div>

            <div className="jg-footer-note">
              <p>Payments go to: <strong>{UPI_ID}</strong></p>
            </div>
          </>
        ) : (
          <>
            {/* Payment Section */}
            <button className="jg-back-btn" onClick={handleBack}>
              ← Back
            </button>

            <div className="jg-payment-header">
              <div className="jg-person-avatar">
                {selectedPerson.name.charAt(0)}
              </div>
              <h2 className="jg-person-name">{selectedPerson.name}</h2>
              <div className="jg-payment-amount">
                ₹{selectedPerson.amount.toLocaleString()}
              </div>
              <p className="jg-payment-note">Your share for Jolly Gunj Party</p>
            </div>

            <div className="jg-qr-section">
              <div className="jg-qr-wrapper">
                <QRCodeSVG
                  value={generateUPIString(selectedPerson.amount)}
                  size={200}
                  level="H"
                  includeMargin={true}
                  fgColor="#5f0848"
                />
              </div>
              <p className="jg-qr-hint">Scan with any UPI app</p>
            </div>

            <div className="jg-upi-id" onClick={copyUpiId}>
              {UPI_ID}
              <span className="jg-copy-hint">{copied ? '✓ Copied' : 'Tap to copy'}</span>
            </div>

            <div className="jg-pay-buttons">
              <button className="jg-pay-btn gpay" onClick={payWithGooglePay}>
                <svg viewBox="0 0 24 24" className="jg-pay-icon">
                  <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                  <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                  <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                  <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                </svg>
                Google Pay
              </button>

              <button className="jg-pay-btn phonepe" onClick={payWithPhonePe}>
                <svg viewBox="0 0 24 24" className="jg-pay-icon" fill="#5F259F">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 15l-4-4 1.41-1.41L11 14.17l6.59-6.59L19 9l-8 8z"/>
                </svg>
                PhonePe
              </button>

              <button className="jg-pay-btn upi" onClick={payWithAnyUPI}>
                Any UPI App
              </button>
            </div>

            <div className="jg-thank-you">
              <p>🙏 Thanks for being part of the fun!</p>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default JollyGunjParty;
